import { AxiosRequestConfig, CreateAxiosDefaults } from "axios";
import { message } from "ant-design-vue";
import Request, { createSecondaryRequest } from "./request";

// 主服务实例
const request = new Request({});

// 图片矫正服务实例
const request2 = createSecondaryRequest();

const handleDownload = (res: any, fileName?: string) => {
  // 解析 Content-Disposition 头来获取文件名
  let _fileName = "";
  // 这里 data 是返回来的二进制数据
  const blob = new Blob([res.data], {
    type: "application/x-msdownload;charset=UTF-8",
  });
  // 创建一个blob的对象链接
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  // 把获得的blob的对象链接赋值给新创建的这个 a 链接
  if (fileName) {
    _fileName = fileName;
  } else {
    const contentDisposition = res.headers ? (res.headers.get("Content-Disposition") as string) : "";
    if (contentDisposition) {
      const filenameRegex = /filename\*=UTF-8''(.*)/;
      const matches = filenameRegex.exec(contentDisposition);

      if (matches && matches[1]) {
        _fileName = decodeURIComponent(matches[1]);
      } else {
        // 如果没有filename*参数，尝试从Content-Disposition中获取文件名
        const filenameRegex2 = /filename=(.*)/;
        const matches2 = filenameRegex2.exec(contentDisposition);

        if (matches2 && matches2[1]) {
          _fileName = matches2[1].replace(/['"]/g, "");
        }
      }
    }
  }
  link.setAttribute("download", _fileName); // 设置下载文件名

  document.body.appendChild(link);
  // 使用js点击这个链接
  link.click();
  document.body.removeChild(link); // 下载完成移除元素
  window.URL.revokeObjectURL(url); // 释放blob对象
};
const downloadFile = (method: string, url: string, config: AxiosRequestConfig, fileName?: string) => {
  let _data = {};
  let _params = {};
  if (method === "GET" || method === "get") {
    _params = config.params;
  } else {
    _data = config.data;
  }
  return new Request({
    url,
    method,
    params: _params,
    headers: config.headers,
    data: _data,
    responseType: "blob",
  })
    .request({
      url,
      method,
      params: _params,
      headers: config.headers,
      data: _data,
      responseType: "blob",
    })
    .then((res) => {
      // 如果文件报错需要转格式才能获取错误信息
      if (res.data.type === "application/json") {
        const reader = new FileReader();
        reader.readAsText(res.data, "urf-8");
        console.log("application/json", reader);
        reader.onloadend = (e) => {
          const data = JSON.parse(e.target?.result as string);
          if (data.message) {
            message.error(data.message);
          } else {
            handleDownload(res, fileName);
          }
        };
      } else {
        handleDownload(res, fileName);
      }
    })
    .catch((err) => {
      console.log(err, "err");
      message.error("下载失败！");
    });
};
export { request, request2, downloadFile };
